<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Plaka</label>
            <v-validator :errors="errors" parameter="PlateValue" :watch="value.PlateValue">
                <input type="text" class="form-control" placeholder="Plaka" v-model="value.PlateValue">
            </v-validator>
        </div>

        <div class="col-12 mb-1">
            <label class="form-label">HGS Numarasi</label>
            <v-validator :errors="errors" parameter="HGSNumber" :watch="value.HGSNumber">
                <input
                    type="text"
                    class="form-control"
                    placeholder="HGS Numarasi"
                    :value="value.HGSNumber"
                    maxlength="10"
                    :disabled="editing"
                    @input="onHGSNumberInput"
                >
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">HGS Baslangic Tarihi</label>
            <v-validator :errors="errors" parameter="HGSStartDate" :watch="value.HGSStartDate">
                <v-date-picker v-model="value.HGSStartDate" placeholder="HGS Baslangic Tarihi" style="width: 100%;" :disabled="editing"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">HGS Sinifi</label>
            <v-validator :errors="errors" parameter="HGSClass" :watch="value.HGSClass">
                <v-select
                    v-model="value.HGSClass"
                    placeholder="HGS Sinifi Seciniz"
                    :options="hgsClasses"
                    label="Text"
                    :reduce="item => item.Value"
                    :disabled="editing"
                />
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">HGS Arac Tipi</label>
            <v-validator :errors="errors" parameter="HGSVehicleClassType" :watch="value.HGSVehicleClassType">
                <v-select
                    v-model="value.HGSVehicleClassType"
                    placeholder="HGS Arac Tipi Seciniz"
                    :options="hgsVehicleTypes"
                    label="Text"
                    :reduce="item => item.Value"
                    :disabled="editing"
                />
            </v-validator>
        </div>

        <div class="col-12 mb-50">
            <b-form-checkbox v-model="value.IsSold">Satildi</b-form-checkbox>
        </div>
        <div class="col-12" v-if="value.IsSold">
            <label class="form-label">Satilma Tarihi</label>
            <v-validator :errors="errors" parameter="SoldDate" :watch="value.SoldDate">
                <v-date-picker v-model="value.SoldDate" placeholder="Satilma Tarihi" style="width: 100%;"/>
            </v-validator>
        </div>
    </div>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue'

export default {
    components: {
        BFormCheckbox
    },
    props: {
        value: Object,
        errors: Object,
        editing: Boolean,
        hgsClasses: { type: Array, default: () => [] },
        hgsVehicleTypes: { type: Array, default: () => [] }
    },
    methods: {
        onHGSNumberInput(event) {
            this.value.HGSNumber = this.normalizeHGSNumber(event?.target?.value)
        },
        normalizeHGSNumber(value) {
            if (!value) return null
            const normalizedValue = value.toString().trim().replace(/\s+/g, '').toUpperCase().slice(0, 10)
            return normalizedValue || null
        }
    }
}
</script>

<style>
</style>
